import React, {Component} from 'react';
// import Immutable from 'immutable';
import clsx from 'clsx';
import getRemainingTime from 'helpers/getRemainingTime'

// import Immutable from 'immutable';
import {withStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
// import { connect } from 'react-redux';
import config from 'config/api'
import Grid from '@material-ui/core/Grid';

// import withWidth from '@material-ui/core/withWidth';
// import isArray from 'mout/lang/isArray';
import IconPlay from '@material-ui/icons/PlayCircleFilled';
// import Paper from '@material-ui/core/Paper';

import AddIcon from '@material-ui/icons/Add';
// import EventIntro from 'components/Event/EventIntro';
// import BlockTitle  from 'components/UI/BlockTitle';
// import BlockButton  from 'components/UI/BlockButton';
// import MyEventsContainer from 'components/Event/MyEventsContainer';
import RemainingTime from 'components/UI/RemainingTime';
import gotoLiveRoom from 'helpers/gotoLiveRoom'

// import Spinner from 'components/UI/Spinner';
// import Header from '../Header/Header';
// import Footer from '../Footer';
// import LiveHelp from './LiveHelp';
// import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
// import Bubble from 'components/UI/Bubble';
// import HelpSpeedTest from 'components/Help/HelpSpeedTest';
import PopinWrapper from 'components/PopinWrapper';
import EventSubscription from 'components/Event/EventSubscription';
import EventSubscriptionFor from 'components/Event/EventSubscriptionFor';
import DialogPopinButton from 'components/UI/Dialog/DialogPopinButton';

// import { Redirect } from 'react-router-dom'
// import { withRouter } from 'react-router-dom'

import {primaryColor} from 'helpers/colors';
import getCardImage from 'helpers/getCardImage';

const styles = (theme) => {
  // console.log(theme)
  return {
    cardRoot: {
      padding: '50px 40px 30px',
      textAlign: 'left',
      maxWidth: 800,
      margin: '0 auto 30px',
      background: 'linear-gradient(278.43deg, #FFCCE7 0%, #30003B 100%)',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
      }
    },
    embed: {
      maxWidth: 'initial',
      padding: '30px 40px 20px',
      margin: '0 auto',
      borderBottom: '1px #fff solid'
    },
    cardImage: {
      position: 'absolute',
      backgroundSize: 'contain',
      top: 30,
      right: 30,
      borderRadius: 90,
      width: 130,
      height: 130,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      border: '1px #ccc solid',
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
        top: 'initial',
        right: 'initial',
        margin: '0 auto 40px'
      }
    },
    cartTitle: {
      fontSize: '33px',
      [theme.breakpoints.down('sm')]: {
        fontSize: '24px',
        marginBottom: '20px'
      }
    },
    cardContent: {
      width: '60%',
      margin: '40px 0',
      [theme.breakpoints.down('sm')]: {
        width: '100%'
      }
    },
    cardContentEmbed: {
      margin: '40px 0 0'
    },
    cardTimeRemaininTitle: {
      color: primaryColor,
      fontSize: '26px',
      marginBottom: 20
    },
    cardButton: {
      fontSize: '11px',
      padding: '15px 40px',
      backgroundColor: '#fff',
      margin: '0 auto 20px',
      display: 'flex',
      color: primaryColor,
      fontWeight: 'bold',
      letterSpacing: '0.92px',
      backgroundImage: 'none',
      '&:hover': {
        color: '#fff',
        backgroundColor: primaryColor,
        backgroundImage: 'none'
      }
    },
    cardTimeRemainin: {
      textAlign: 'center',
      margin: '0 auto 40px',
      [theme.breakpoints.down('sm')]: {
        marginBottom: 20
      }
    }
  }
}
class EventCardSimple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      remainingTime: 0,
      remainingTimeDays: 0,
      remainingTimeHours: 0,
      remainingTimeMinutes: 0
    }
    this._runRemainingTimer = this._runRemainingTimer.bind(this);
    this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
  }
  componentDidMount() {
    if (this.props.showRemainingTime === true)
    this._startTimer();

  }
  componentDidUpdate(oldProps) {
    if (this.props.showRemainingTime === true && oldProps.$$data === undefined && this.props.data !== undefined) {
      // console.log('startIcon')
      this._startTimer();
    }
  }
  componentWillUnmount() {
    this._stopTimer();
  }
  _stopTimer() {
    if (this._remainingTimer) {
      clearInterval(this._remainingTimer);
    }
  }
  _startTimer() {
    // const $$card = this._getCard();
    const {$$card} = this.props;
    if ($$card === undefined)
    return;
    this._cardTimer = $$card.get('eventDate');
    this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
    this._runRemainingTimer();
  }
  // _runRemainingTimer() {
  //
  //   // var countDownDate = new Date("Jan 5, 2021 15:37:25").getTime();
  //   var countDownDate = this._cardTimer;
  //   // console.log('countDownDate', countDownDate)
  //   if (!countDownDate)
  //   return;
  //   var now = new Date().getTime();
  //   var distance = (countDownDate * 1000) - now;
  //
  //   var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  //   var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  //   var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  //   // var seconds = Math.floor((distance % (1000 * 60)) / 1000);
  //
  //   const tStr = days + " Jour" + (
  //     days > 1
  //     ? 's'
  //     : '') + " " + hours + " Heure" + (
  //       hours > 1
  //       ? 's'
  //       : '') + " " + minutes + " Minute" + (
  //         minutes > 1
  //         ? 's'
  //         : '') + "";
  //         this.setState({remainingTime: tStr, remainingTimeDays: days, remainingTimeHours: hours, remainingTimeMinutes: minutes})
  //         if (distance < 0) {
  //           clearInterval(this._remainingTimer);
  //         }
  //       }
  //
  //       // _gotoLiveRoom() {
  //       //   // const $$card = this._getCard();
  //       //   const {$$card} = this.props;
  //       //   // console.log('click', $$card.toJS())
  //       //   if ($$card !== undefined && $$card.get('eventLinkExternal') !== undefined && $$card.get('eventLinkExternal') !== null && $$card.get('eventLinkExternal') !== false) {
  //       //     // window.open($$card.get('eventLinkExternal'))
  //       //     const url = config.events + '/redir/' + $$card.get('id');
  //       //     console.log('redirecting to', url);
  //       //     window.open(url);
  //       //   }
  //       //
  //       // }

  _runRemainingTimer() {
    // console.log('run1')
    // const { $$card } = this.props;
    // const $$liveEvent = $$card;
    const $$liveEvent = this._getCard();
    // console.log('run2', $e)
    if ($$liveEvent === undefined) {
      return this._stopTimer();
    }
    // console.log('run3')
    // console.log($e)
    // console.log($e.get('eventState'))
    const timeRemaining =
    $$liveEvent !== undefined && $$liveEvent.get("eventState") != "live"
    ? getRemainingTime($$liveEvent.get("eventDate"))
    : { days: 0, hours: 0, minutes: 0 };
    // console.log(timeRemaining)
    if (
      timeRemaining.days <= 0 &&
      timeRemaining.hours <= 0 &&
      timeRemaining.minutes <= 0
    ) {
      this.setState({ showLiveButton: true }, () => {
        // console.log('STOPPPING')
        this._stopTimer();
      });
    } else {
      // console.log('RUN')
      this.setState({ timeRemaining });
    }
  }

        _gotoLiveRoom() {
          // const $$card = this._getCard();
          // const {$$card, history} = this.props;
          // // console.log('click', $$card.toJS())
          // if ($$card !== undefined && $$card.get('eventLinkLive') !== undefined && $$card.get('eventLinkLive') !== null && $$card.get('eventLinkLive') !== false) {
          //   // window.open($$card.get('eventLinkExternal'))
          //   history.push('/live/'+$$card.get('id'));
          //   // const url = config.events + '/redir/' + $$card.get('id');
          //   // console.log('redirecting to', url);
          //   // window.open(url);
          // }
          // else if ($$card !== undefined && $$card.get('eventLinkExternal') !== undefined && $$card.get('eventLinkExternal') !== null && $$card.get('eventLinkExternal') !== false) {
          //   // window.open($$card.get('eventLinkExternal'))
          //   const url = config.events + '/redir/' + $$card.get('id');
          //   console.log('redirecting to', url);
          //   window.open(url);
          // }
          // e.preventDefault();
          const { $$card } = this.props;
          gotoLiveRoom($$card, () => {
              this._goto('/live/'+$$card.get('id'))
          })
          // console.log('click', $$card.toJS())

        }
        _getCard() {
          const {$$data} = this.props;
          return $$data !== undefined && $$data.get('live') !== undefined && $$data.get('live').size > 0
          ? $$data.get('live').get(0)
          : undefined
        }

        render() {
          const {
            // $$data,
            userRole,
            // onPanelToggle,
            classes,
            $$card,
            // $$subscriptions,
            onSubscriptionComplete,
            showRemainingTime,
            embed
          } = this.props;

          const cardImage = getCardImage($$card);
          // console.log({cardImage})

          // const {remainingTimeDays, remainingTimeHours, remainingTimeMinutes} = this.state;
          const { timeRemaining, showLiveButton } = this.state;

          return (<React.Fragment>
            <If condition={showRemainingTime !== false && timeRemaining !== undefined && showLiveButton !== true && (timeRemaining.days >= 0 || timeRemaining.hours >= 0 || timeRemaining.minutes >= 0)}>

              <Grid item="item" xs={12}>
                <div className={classes.cardTimeRemainin}>
                  <Typography variant="h4" className={classes.cardTimeRemaininTitle}>La conférence débute dans :</Typography>
                  <RemainingTime days={timeRemaining.days} hours={timeRemaining.hours} minutes={timeRemaining.minutes}/>
                </div>
              </Grid>
            </If>
            <Box className={clsx(classes.cardRoot, {
                [classes.embed]: embed
              })}>

              <Box className={classes.cardImage} style={{
                  backgroundImage: cardImage !== false
                  ? 'url(' + cardImage + ')'
                  : 'none'
                }}></Box>

                <Typography variant={'caption'} gutterBottom={true}>Animé par :</Typography>
                <Typography variant={'subtitle1'} gutterBottom={true}>{$$card.get('eventGuests')}</Typography>
                <If condition={$$card.get('eventLocation') !== undefined}>
                  <Typography variant={'subtitle1'} gutterBottom={true}>{$$card.get('eventLocation')}</Typography>
                </If>

                <div className={clsx(classes.cardContent, {
                    [classes.cardContentEmbed]: embed
                  })}>
                  <Typography variant={'h2'} color={'textSecondary'} gutterBottom={true} className={classes.cartTitle}>{$$card.get('eventTitle')}</Typography>
                  <Typography variant={'body2'} gutterBottom={true}>{$$card.get('eventDescription')}</Typography>
                </div>

                <If condition={embed !== true}>
                  <If condition={userRole !== undefined && userRole !== 'visitor' && $$card.get('eventState') !== 'replay'}>
                    <Button size="large" className={classes.cardButton} onClick={this._gotoLiveRoom} endIcon={<IconPlay/>}>
                      <span>Accéder au live</span>
                    </Button>
                  </If>
                  <If condition={userRole === 'member'}>
                    <DialogPopinButton trigger={PopinWrapper} triggerProps={{
                        className: classes.cardButton,
                        label: "S'inscrire",
                        endIcon: <AddIcon/>,
                      size: 'large',
                      icon: false,
                      button: true
                    }} popinTitle={false} popinTitleStyle={{
                      paddingBottom: 0,
                      height: 1
                    }} popinContent={EventSubscription} popinContentProps={{
                      $$event: $$card,
                      userRole
                    }} openOnMount={false} onClosed={onSubscriptionComplete}/>
                  </If>
                  <If condition={userRole === 'staff' || userRole === 'admin'}>
                    <DialogPopinButton trigger={PopinWrapper} triggerProps={{
                        className: classes.cardButton,
                        label: "Inscrire",
                        endIcon: <AddIcon/>,
                      size: 'large',
                      icon: false,
                      button: true
                    }} popinTitle={<span> Inscription à une conférence</span>} popinContent={EventSubscriptionFor} popinContentProps={{
                      $$event: $$card,
                      userRole
                    }} openOnMount={false} onClosed={onSubscriptionComplete}/>
                  </If>
                </If>
              </Box>
            </React.Fragment>);
          }
        }

        // export default ;
        export default withStyles(styles)(EventCardSimple);



// WEBPACK FOOTER //
// ./src/components/Event/EventCardSimple.jsx